/**
 * @file The current time in milliseconds, ticking once a second, that a
 * cooldown countdown recomputes its time left from at render. Consumers:
 * `AnalyticsRecomputeButton` and `AnalyticsReportRunActions`. The interval is
 * the only effect a countdown needs and stops when the caller unmounts.
 */
import { useEffect, useState } from 'react';

const CLOCK_INTERVAL_MS = 1_000;

export const useAnalyticsCooldownClock = (): number => {
  const [now, setNow] = useState(Date.now);

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), CLOCK_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return now;
};
